var _path, _g, _g2, _g3, _path2, _g4, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAmplify = function SvgAmplify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#amplify_svg__a)",
    d: "M100 53.334A6.666 6.666 0 0 1 106.667 60l.005 66.667a6.666 6.666 0 0 1-6.666 6.667l-66.666.005a6.667 6.667 0 0 1-6.668-6.666l-.005-66.667a6.667 6.667 0 0 1 6.667-6.667L100 53.334Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#amplify_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#amplify_svg__c)",
    d: "M126.666 26.661a6.666 6.666 0 0 1 6.667 6.667l.005 66.666a6.666 6.666 0 0 1-6.666 6.667l-66.666.005A6.667 6.667 0 0 1 53.337 100l-.005-66.667A6.667 6.667 0 0 1 60 26.666l66.666-.005Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    filter: "url(#amplify_svg__d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.667,
    height: 6.667,
    x: 73.336,
    y: 46.667,
    rx: 3.333
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.667,
    height: 6.667,
    x: 73.336,
    y: 60,
    rx: 3.333
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.667,
    height: 6.667,
    x: 73.336,
    y: 73.334,
    rx: 3.333
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#amplify_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#amplify_svg__f)",
    d: "M27 125c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M23.895 96.553a1 1 0 0 0-1.79 0l-2.99 5.982-.019.037-.99 1.981a1 1 0 1 0 1.789.894l.723-1.447h4.764l.714 1.428a1 1 0 0 0 .926.572h.905a7.02 7.02 0 0 0 1.548 4.265c-.706.394-1.556.66-2.553.738a1 1 0 0 0 .156 1.994c1.562-.123 2.873-.607 3.922-1.322 1.05.715 2.36 1.199 3.922 1.322a1 1 0 0 0 .157-1.994c-.998-.078-1.848-.344-2.553-.738A7.021 7.021 0 0 0 34.073 106H35a1 1 0 0 0 0-2h-3v-1a1 1 0 0 0-2 0v1h-2.382l-.714-1.428a.637.637 0 0 0-.018-.037l-2.991-5.982ZM32.073 106h-2.146A4.991 4.991 0 0 0 31 108.97a4.991 4.991 0 0 0 1.073-2.97Zm-7.69-4L23 99.236 21.618 102h2.764ZM23 106a1 1 0 0 1 1 1v1h1a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1Zm7-6a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1h-2a1 1 0 1 0 0 2h1v1Z",
    clipRule: "evenodd"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#amplify_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#amplify_svg__h)",
    d: "M136 50c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M129 34a7 7 0 1 1 3.504 6.066.997.997 0 0 0-.757-.1l-2.365.63.61-2.44a1 1 0 0 0-.099-.732A6.969 6.969 0 0 1 129 34Zm7-9a9 9 0 0 0-8.042 13.045l-.928 3.712a1 1 0 0 0 1.228 1.21l3.618-.966A9 9 0 0 0 145 34a9 9 0 0 0-9-9Zm4 9c0 .17-.011.337-.031.5a.494.494 0 0 0-.18.047c-.473.22-.925.401-1.364.544a8.001 8.001 0 0 0 0-2.182c.439.143.891.324 1.364.544a.494.494 0 0 0 .18.046c.02.164.031.331.031.501Zm-1.799 2.2c.463-.123.933-.285 1.413-.484a4.013 4.013 0 0 1-1.898 1.898c.199-.48.361-.95.485-1.413ZM137.5 34c0 .45-.044.903-.133 1.367-.464.09-.917.133-1.367.133-.45 0-.903-.044-1.367-.133A7.217 7.217 0 0 1 134.5 34c0-.45.044-.903.133-1.367.464-.09.917-.133 1.367-.133.45 0 .903.044 1.367.133.089.464.133.917.133 1.367Zm-1.5 2.5c-.364 0-.727-.025-1.091-.075.143.44.324.892.544 1.364a.51.51 0 0 1 .046.18 4.035 4.035 0 0 0 1.002 0 .51.51 0 0 1 .046-.18c.22-.473.401-.925.544-1.364-.364.05-.727.075-1.091.075Zm-2.5-2.5c0 .364.025.727.075 1.091a12.124 12.124 0 0 1-1.364-.544.494.494 0 0 0-.18-.046 4.136 4.136 0 0 1 0-1.002.494.494 0 0 0 .18-.046c.473-.22.925-.401 1.364-.544A8 8 0 0 0 133.5 34Zm.299 2.2a11.407 11.407 0 0 1-1.413-.484 4.013 4.013 0 0 0 1.898 1.898c-.199-.48-.361-.95-.485-1.413Zm5.815-3.916a4.013 4.013 0 0 0-1.898-1.898c.199.48.361.95.485 1.413.463.124.933.286 1.413.485Zm-2.523-.71a12.143 12.143 0 0 0-.544-1.363.51.51 0 0 1-.046-.18 4.035 4.035 0 0 0-1.002 0 .51.51 0 0 1-.046.18c-.22.473-.401.925-.544 1.364a8.065 8.065 0 0 1 2.182 0Zm-3.292.225c.124-.463.286-.933.485-1.413a4.013 4.013 0 0 0-1.898 1.898c.48-.199.95-.36 1.413-.485ZM141 34a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "amplify_svg__a",
    x1: 80.003,
    x2: 44.503,
    y1: 56.5,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#598CC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5183BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "amplify_svg__c",
    x1: 113.497,
    x2: 62.497,
    y1: 27,
    y2: 107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BB3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#588BC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "amplify_svg__f",
    x1: 27,
    x2: 27,
    y1: 85,
    y2: 125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E7C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DD1B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "amplify_svg__h",
    x1: 136,
    x2: 136,
    y1: 18,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC52E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB03"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "amplify_svg__b",
    width: 120.005,
    height: 120.005,
    x: 33.333,
    y: 12.661,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.139561 0 0 0 0 0.35972 0 0 0 0 0.566537 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4742_100523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4742_100523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "amplify_svg__d",
    width: 66.667,
    height: 53.334,
    x: 63.336,
    y: 40.667,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.139561 0 0 0 0 0.35972 0 0 0 0 0.566537 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4742_100523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4742_100523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "amplify_svg__e",
    width: 50.074,
    height: 50.074,
    x: 4.481,
    y: 82.481,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.519,
    dy: 2.519
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.519
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0846528 0 0 0 0 0.150363 0 0 0 0 0.383333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4742_100523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4742_100523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "amplify_svg__g",
    width: 40.059,
    height: 40.059,
    x: 117.985,
    y: 15.985,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.015,
    dy: 2.015
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.015
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0846528 0 0 0 0 0.150363 0 0 0 0 0.383333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4742_100523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4742_100523",
    result: "shape"
  })))));
};
export default SvgAmplify;